module Meevo.Plugins.BusinessInfo {
    "use strict";

    /**
    * MeevoUrl Section of BusinessInfo 
    */
    export class MeevoUrlSection extends Meevo.Components.CommonClasses.CommonSectionBase {

        private urls = [];

        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            noun: Meevo.Model.NounEnum = null,
            identityService: Components.Common.IIdentityService = null,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected $rootScope: angular.IRootScopeService,
            protected $mdToast: angular.material.IToastService,
            protected $translate: angular.translate.ITranslateService,
            sectionSecurityKey?: string) {

            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, noun, identityService, sectionSecurityKey)

            this.$rootScope.$on(Meevo.Components.Common.Messages.RDS_RESPONSE, (evt, mes, res) => {
                if (mes === this.$translate.instant('ERROR_HTTP_422_RDSSERVER_URLEXIST')) {
                    this.urls.push(this.model.subDomainUrl);
                }
                this.rdsResponseHandler(mes, res, evt);
            });
           
        }

        rdsResponseHandler(mes: any, res: any, evt?: any): void {
            this.handleMessage(mes, evt);
        }

        preSave(): any {
            if (this.urls.indexOf(this.model.subDomainUrl) > -1) {
                this.handleMessage(this.$translate.instant('ERROR_HTTP_422_RDSSERVER_URLEXIST'))
                throw ('Url Exist Error!!')
            } 
            super.preSave()
        }

        handleMessage = (mes: any, $event?: any) => {
            let subDomainUrl = angular.element('input#subDomainUrl')

            var toast = this.$mdToast.simple();
            toast.textContent(mes);
            toast.position("top right");            /*  Overridden by toastClass     */
            //toast.parent(subDomainUrl);           /*  Depends on parent positioning   -   Commented Out No Working*/
            toast.hideDelay(1500);
            toast.action("X");
            toast.toastClass('invalid');            /*  Overrides Positioning   */
            this.$mdToast.show(toast);

        }

    }
}